<script setup>
import SideSlider from "~/components/templates/SideSlider.vue";
import SpoilerTabs from "~/components/molecules/SpoilerTabs.vue";
import FilterGrid from "~/components/molecules/FIlterGrid.vue";

const props = defineProps({
  openFilter: Number,
  filter: {
    type: Array,
    default: () => [],
  },
  chosenFilters: {
    type: Object,
    default: () => ({}),
  },
})

const emit = defineEmits(['change'])

const active = ref(false)
const key = ref(Math.random())

const localChosen = ref({...props.chosenFilters})

watch(() => props.chosenFilters, (value) => {
  localChosen.value = {...(value || {})}
  key.value = Math.random()
}, {deep: true})

watch(() => props.openFilter, () => {
  active.value = true
})

const getTabSlotName = (index) => `tab-content-${index}`

const handleClick = ({name, value}) => {
  if (!localChosen.value[name]) {
    localChosen.value[name] = []
  }

  if (localChosen.value[name].includes(value)) {
    localChosen.value[name] = localChosen.value[name].filter(item => item !== value)
  } else {
    localChosen.value[name].push(value)
  }

  if (localChosen.value[name].length === 0) {
    delete localChosen.value[name]
  }

  emit('change', {...localChosen.value})
}

const clearFilter = () => {
  localChosen.value = {}
  emit('change', {})
}

defineExpose({
  handleClick,
  clearFilter,
})
</script>

<template>
  <div class="filter">
    <SideSlider :title="$t('base.filter_action')" @close="active=false" :active="active">
      <SpoilerTabs
        v-if="filter.length"
        :classic-separator="false"
        :arrows="false"
        :tabs="filter.map(filterItem => ({title: filterItem.title, opened: filterItem.opened}))"
      >
        <template v-slot:[getTabSlotName(index)] v-for="(filterItem, index) in filter">
          <div class="filter-block" :class="[filterItem.slug, {'text': filterItem.is_text}]">
            <FilterGrid
              :chosenFilters="localChosen"
              :key="key"
              @click="handleClick"
              :filter-item="filterItem"
            />
          </div>
        </template>
      </SpoilerTabs>
    </SideSlider>
  </div>
</template>

<style scoped lang="scss">
.filter {
  &:deep(.tab) {
    height: fit-content !important;

    .heading, .tab-content {
      padding: 0 24px;
    }

    .heading {
      text-transform: uppercase;
    }
  }

  .filter-block {
    max-height: 420px;
    overflow-y: auto;
    gap: 18px;
    margin-left: -10px;
    padding-bottom: 20px;

    &.text {
      margin-left: 0;
    }
  }

  &:deep(.main-block.active) {
    @include mobile {
      max-width: 86%;
    }
  }
}
</style>
